import { render, staticRenderFns } from "./IP_DocAssessment.vue?vue&type=template&id=2d8e0bdc&scoped=true&"
import script from "./IP_DocAssessment.vue?vue&type=script&lang=js&"
export * from "./IP_DocAssessment.vue?vue&type=script&lang=js&"
import style0 from "./IP_DocAssessment.vue?vue&type=style&index=0&id=2d8e0bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8e0bdc",
  null
  
)

export default component.exports